module.exports = __webpack_public_path__ + "static/11-9cc0d345ad3afde750031a85ae2da729.jpg";